import { UIElement } from '../ui-element.js';
import { html } from '../../global/template-literals.js';
import styles from './ui-header-toolbar.css';

/**
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIHeaderToolbar
 * @element ui-header-toolbar
 * @classdesc Represents a class for <code>ui-header-toolbar</code> element.
 * @slot {@name environment} Environment selector slot.
 * @slot {@name language} Language selector slot.
 * @slot {@name login-button} Login button selector slot.
 * @example
 * <ui-header-toolbar>
 * </ui-header-toolbar>
 */

class UIHeaderToolbar extends UIElement {
    /**
     * @inheritDoc
     */
    render() {
        const environmentToggle = this.getChildrenForSlot('environment')[0];
        const languageSelector = this.getChildrenForSlot('language')[0];
        const loginButton = this.getChildrenForSlot('login-button')[0];
        const toolbarNodes = this.detachChildNodes();

        environmentToggle?.classList.add('ui-header-toolbar__environment');
        languageSelector?.classList.add('ui-header-toolbar__language');
        loginButton
            ?.closest('button')
            ?.classList.add('ui-header-toolbar__login');

        this.append(
            html` ${environmentToggle} ${toolbarNodes} ${languageSelector}
            ${loginButton}`
        );
    }
}

UIHeaderToolbar.defineElement('ui-header-toolbar', styles);
export { UIHeaderToolbar };
